import SelectAllController from './select_all_controller'
import { current } from '../helpers'
import { repositoryVaultsPath, repositoryVaultNoticesPath } from '../routes'

const VAULTS_FRAME_ID = 'repository_vaults'
const NOTICES_FRAME_ID = 'repository_notices'

export default class extends SelectAllController {
  static targets = [
    'projectSelect', 'submitButton', 'vaultsContainer',
    'projectStep', 'vaultStep'
  ]

  connect () {
    const frame = document.getElementById(VAULTS_FRAME_ID)
    if (frame) this.initialEmptyState = frame.innerHTML
  }

  selectProject () {
    this.resetSubmitButton()
    this.clearNotices()
    if (this.projectId) {
      this.loadVaults()
      this.setStepState(this.projectStepTarget, 'done')
      this.setStepState(this.vaultStepTarget, 'active')
    } else {
      this.resetVaults()
      this.setStepState(this.projectStepTarget, 'active')
      this.setStepState(this.vaultStepTarget, 'disabled')
    }
  }

  selectVault ({ target }) {
    this.loadNotices(target.value)
    this.setStepState(this.vaultStepTarget, 'done')
    this.submitButtonVisible = true
    this.submitButtonDisabled = false
  }

  // Private

  loadVaults () {
    const frame = document.getElementById(VAULTS_FRAME_ID)
    if (!frame) return
    this.showSkeleton(frame, this.cardsGridSkeleton())
    frame.src = repositoryVaultsPath(current.account.id, this.projectId)
  }

  loadNotices (vaultId) {
    const frame = document.getElementById(NOTICES_FRAME_ID)
    if (!frame) return
    frame.src = repositoryVaultNoticesPath(current.account.id, this.projectId, vaultId)
  }

  clearNotices () {
    const frame = document.getElementById(NOTICES_FRAME_ID)
    if (!frame) return
    frame.removeAttribute('src')
    frame.innerHTML = ''
  }

  resetVaults () {
    const frame = document.getElementById(VAULTS_FRAME_ID)
    if (!frame || this.initialEmptyState == null) return
    frame.removeAttribute('src')
    frame.innerHTML = this.initialEmptyState
  }

  get projectId () {
    const hidden = this.element.querySelector('input[type="hidden"][name="repository[project_id]"]')
    return hidden?.value || this.projectSelectTarget.value
  }
}
